import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.default,,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  ssologo: {
    height: '100px',
    backgroundSize: '40%',
    marginTop: '20px'
  },
  ssocard: {
    width: '70%',
    margin: 'auto',
    boxShadow:
      '0px 0px 10px 2px rgb(63 63 68 / 5%), 0 1px 2px 0 rgb(63 63 68 / 15%)',
    border: 'none',
    padding: theme.spacing(3),
    borderRadius: '12px'
  },
  circularProgress: {
    marginRight: '10px'
  },
  alert: {
    marginTop: '10px'
  },
  cardContent: {
    padding: theme.spacing(3)
  }
}));
